/**
 * Copies V1 générées par les éthogrammes V2 (`obsProfile` marqué `managedBy: 'ethogramV2'`).
 *
 * Personne ne les modifie à la main : la recopie automatique suivante écraserait la
 * modification, et l'enregistrement complet de l'éditeur V1 écraserait la copie.
 * Elles se consultent et se dupliquent ; la duplication donne un éthogramme V1 ordinaire.
 * ADR : docs/decisions/2026-10-23-ethogrammes-v2-arbre-et-registre.md (décision 7).
 */

export const ETHOGRAM_V2_MANAGER = "ethogramV2";

/** Code d'échec renvoyé par les connecteurs qui refusent d'écrire une copie V2. */
export const MANAGED_BY_V2_ERROR = "MANAGED_BY_V2";

export const isManagedByEthogramV2 = (profile) => profile?.managedBy === ETHOGRAM_V2_MANAGER;

// Champs propres à la copie V2 : sur l'éthogramme, puis sur chaque comportement.
const PROFILE_V2_FIELDS = ["managedBy", "v2", "v2EthogramId"];
// `parentBehaviorId` (modificateur) est un identifiant du registre, comme `behaviorId` ;
// `parentOptionId` reste : il ne sert qu'à ranger la précision sous son comportement.
const BEHAVIOR_V2_FIELDS = ["behaviorId", "behaviorKind", "parentBehaviorId"];

const omit = (source, keys) => {
  const copy = { ...source };
  keys.forEach((key) => delete copy[key]);
  return copy;
};

/**
 * Éthogramme V1 ordinaire tiré d'une copie V2 (duplication) : sans marque de gestion
 * ni lien vers la V2, et sans `behaviorId` sur les comportements (le texte de la copie
 * peut ensuite changer de sens, l'identifiant du registre ne le suivrait pas).
 */
export function withoutEthogramV2Fields(entry) {
  if (!entry || typeof entry !== "object") return entry;
  const fromV2 = isManagedByEthogramV2(entry) || Boolean(entry.v2);
  const copy = omit(entry, PROFILE_V2_FIELDS);
  if (fromV2 && copy.categoriesOptions && typeof copy.categoriesOptions === "object") {
    copy.categoriesOptions = Object.fromEntries(Object.entries(copy.categoriesOptions).map(([categoryId, behaviors]) => [
      categoryId,
      Array.isArray(behaviors) ? behaviors.map((behavior) => (behavior && typeof behavior === "object" ? omit(behavior, BEHAVIOR_V2_FIELDS) : behavior)) : behaviors,
    ]));
  }
  return copy;
}
